import { DispatcherEvent } from '@carvana/merch-native';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { getUserProfile } from '@/vdp/VehicleDetailsContainer/actions';
import { AccountModalSettings } from '~/contracts/common';
import {
  type AddFavoritesFlow,
  type FavoritesArguments
} from '~/hooks/common/favorites';
import { getIsLoggedIn } from '~/selectors';
import { closeAccountModal, openAccountModal } from '~/utilities/accountModal';

const defaultModalSettings: AccountModalSettings = {
  modalTitle: 'SAVE TO FAVORITES'
};

type AppDispatch = ThunkDispatch<{}, any, AnyAction>;

function useLogInAndFavorite(): AddFavoritesFlow {
  const dispatch = useDispatch<AppDispatch>();
  const isLoggedIn = useSelector(getIsLoggedIn);

  return useMemo(
    () =>
      (onContinue: (args: FavoritesArguments) => void) =>
      async (args: FavoritesArguments) => {
        if (isLoggedIn) {
          onContinue(args);

          return;
        }

        const { modalSettings = defaultModalSettings } = args;

        openAccountModal({
          callerIdentifier: 'AccountCreationForm',
          nativeOptions: {
            eventPayload: {
              stockNumber: args.stockNumber,
              subscribeToNotifications: args.subscribeToNotifications,
              vehicleId: args.vehicleId
            },
            eventDispatch: DispatcherEvent.AddFavorite,
            eventSource: 'vdp'
          },
          onSuccess: () => {
            dispatch(getUserProfile(new AbortController()));
            closeAccountModal();
            onContinue(args);
          },
          ...modalSettings
        });
      },
    [dispatch, isLoggedIn]
  );
}

export default useLogInAndFavorite;
